import { useFormatPrice } from '@packages/shared/src/hooks/useFormatPrice/useFormatPrice';
import type { InstallmentData } from '../../types';

export type InstallmentPriceVariation = 'MonthlyInstallment' | 'CalulationBasis' | 'PaymentPlanRow';

export type InstallmentPriceProps = {
  /**
   * the currency of the price (e.g. 'EUR')
   */
  currency: InstallmentData['currency'];
  /**
   * the calculated installment value as float
   */
  installmentValue: number;
  /**
   * defines the layout variation the price will be displayed in
   */
  variation?: InstallmentPriceVariation;
};

/**
 * installment price atom
 *
 * atom to display the calculated installment price
 *
 * */
export const InstallmentPrice = ({
  currency,
  installmentValue,
  variation,
  ...props
}: InstallmentPriceProps) => {
  const { formatPrice } = useFormatPrice();

  switch (variation) {
    case 'PaymentPlanRow': {
      return (
        <div {...props} className="text-size-body2 text-nowrap">
          {formatPrice(installmentValue, currency, true)}
        </div>
      );
    }
    case 'CalulationBasis': {
      return (
        <div {...props} className="text-size-body1 text-nowrap">
          {formatPrice(installmentValue, currency, true)}
        </div>
      );
    }
    case 'MonthlyInstallment':
    default: {
      return (
        <div {...props} className="text-size-h1 text-nowrap">
          {formatPrice(installmentValue, currency, true)}
        </div>
      );
    }
  }
};
